var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-indicators justify-content-center"},[_c('div',{staticClass:"col-8 d-flex justify-content-center"},_vm._l((_vm.levels),function(level,index){return _c('div',{key:index,staticClass:"indicator",class:{
        active: _vm.currentLevel >= index + 1,
        inactive: _vm.currentLevel < index + 1
      },style:({
        width: _vm.indicatorWidth,
        backgroundColor: _vm.getIndicatorColor(index)
      })},[_c('span',{staticClass:"indicator-text"})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }